import styled from "styled-components";

import Cookies from 'js-cookie';
import { Minus, Plus, StripeBg2, StripeBgAr2 } from "../../../ui/AllImages";

export const FaqsWrapper = styled.section`
    padding: 0px 0 0px 0;
    .faqsBg{
        padding-top: 10px;
        padding-bottom: 80px;
    }
    .faqsMainHeading{
        margin-bottom: 45px;
    }
    .accordion-item{
        margin-bottom: 12px;
        background: transparent;
        border: none;
        border-radius: 16px;
        border: 1px solid var(--bg2);
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, .1);
        
        .accordion-button{
            background-color: transparent;
            box-shadow: none;
            font-size: 18px;
            font-family: var(--bold);
            color: var(--secondaryColor);
            padding: 20px 60px 20px 20px;
            background-image: url(${Plus});
            background-repeat: no-repeat;
            background-position: right 19px top 19px;
            text-align: left;
            &:after{
                display: none;
            }
        }
        .accordion-body{
            padding-top: 0;
            font-size: 16px;
            color: var(--bg2);
            /* padding-right: 60px;
            padding-left: 20px; */
        }
        &.active-item{
            background: var(--themeColor);
            .accordion-button{
                color: var(--bg2);
                background-image: url(${Minus});
            }
        }
    }
    .stripe{
        display: flex;
        width: 100%;
        height: 57px;
        background-size: auto;
        background-position: center;
        margin-top: 20px;
    }
    .stripe1{
        background-image: url(${StripeBg2});
    }
    body.rtl &{
        .accordion-item{
           
            .accordion-button{
                background-position: left 19px top 19px;
                font-family: var(--arRegular);
                padding: 20px 20px 20px 60px;
                text-align: right;
            }
            .accordion-body{
                font-family: var(--arLT);
                /* padding-right: 20px;
                padding-left: 60px; */
            }
        }
        .stripe1{
            background-image: url(${StripeBgAr2});
        }
    }
    
    @media (max-width: 1199px) {
        .stripe1{
            background-size: 160% auto;
            background-repeat: no-repeat;
            background-position: center;
        }
    }
    @media (max-width: 767px) {
        .faqsBg {
            padding-bottom: 40px;
        }
        .stripe{
            height: 30px;
        }
        .stripe1{
            background-size: 250% auto;
        }
    }
    @media (max-width: 991px) {
        &{
            padding-top: 60px;
        }
    }

`
export const FaqsCardWrapper = styled.div`
    margin-top: -115px;
    .featuresColContent{
        background-color: var(--white);
        
        background-repeat: repeat;
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0px 20px 50px -10px rgba(0, 0, 0, .2);
        height: 100%;
        position: relative;
        padding: 40px 25px 320px 25px;
        & > *{
            position: relative;
            z-index: 5;
        }
        &:after{
            content: "";
            width: 100%;
            bottom: 0px;
            background: linear-gradient(20deg, rgba(255, 255, 255, 0.99) 50%, rgba(0, 0, 0, 0) 100%);
            position: absolute;
            z-index: 1;
            height: 410px;
            left: 0px;
            right: 0px;
            z-index: 0;
        }
        span{
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 5;
        }
    }
    
    
`

